import { render, staticRenderFns } from "./CardEndereco.vue?vue&type=template&id=4e208a84"
import script from "./CardEndereco.vue?vue&type=script&lang=js"
export * from "./CardEndereco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports